<template>
  <div class="sidebar-footer">
    <img
      src="static/img/labs_logo.svg"
      class="labs-logo"
      alt="labs-img"
    >
  </div>
</template>
<script>

export default {
  name: 'SidebarFooter'
}
</script>
